<app-image-input-control [tagControl]="formControl" [formlyAttributes]="field"></app-image-input-control>
